import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import * as firebase from 'firebase';
@Component({
  selector: 'container',
  templateUrl: './app.container.html',
  styleUrls: ['./app.container.css']
})

export class AppContainer {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {

    if(environment.production === true) {

      let config = {
        apiKey: environment.firebase_apiKey,
        authDomain: environment.firebase_authDomain,
        databaseURL: environment.firebase_databaseURL,
        projectId: environment.firebase_projectId,
        storageBucket: environment.firebase_storageBucket,
        messagingSenderId: environment.firebase_messagingSenderId
      };

      try {
        firebase.initializeApp(config);
        if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
          // Additional state parameters can also be passed via URL.
          // This can be used to continue the user's intended action before triggering
          // the sign-in operation.
          // Get the email if available. This should be available if the user completes
          // the flow on the same device where they started it.
          var email = window.localStorage.getItem('emailForSignIn');
          if (!email) {
            // User opened the link on a different device. To prevent session fixation
            // attacks, ask the user to provide the associated email again. For example:
            email = window.prompt('Please provide your email for confirmation');
          }
          // The client SDK will parse the code from the link for you.
          firebase.auth().signInWithEmailLink(email, window.location.href)
            .then(function (result) {
              // Clear email from storage.
              window.localStorage.removeItem('emailForSignIn');
              // You can access the new user via result.user
              // Additional user info profile not available via:
              // result.additionalUserInfo.profile == null
              // You can check if the user is new or existing:
              // result.additionalUserInfo.isNewUser
            })
            .catch(function (error) {
              // Some error occurred, you can inspect the code: error.code
              // Common errors could be invalid email and invalid or expired OTPs.
            });
        }
      } catch (error) {}

      firebase.auth().onAuthStateChanged(user => {
        window.onbeforeunload = function () {
          // if (window.localStorage.getItem('loggedIn')) {
          //firebase.database().ref('/loggedInUsers/' + user.email.replace(/[^0-9a-z]/gi, '')).remove();
          window.localStorage.removeItem('loggedIn');
          window.localStorage.removeItem('emailForSignIn');
          firebase.auth().signOut();
          // }
        };

        if (user) {
          firebase.database().ref('/loggedInUsers/').once('value').then(function (snapshot) {
            if (
              Object
                .values(snapshot.val() || {})
                .map(function(el: any) {
                  if(typeof el === 'object' && el.hasOwnProperty('email')) {
                    return el.email.toLowerCase();
                  }

                  return el;
                })
                .includes(user.email.replace(/[^0-9a-z]/gi, ''))
            ) {
              firebase.auth().signOut()
              window.localStorage.removeItem('loggedIn');
              // firebase.database().ref('/loggedInUsers/' + user.email.split('@')[0] + user.email.split('@')[1].split('.').join('')).remove();
            } else {
              firebase.database().ref('/loggedInUsers/' + user.email.replace(/[^0-9a-z]/gi, '')).set({
                email: user.email,
              });
              window.localStorage.setItem('loggedIn', 'loggedIn');
            }
          })
        }
      });

    }

  }
}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/app-container/app.container.ts